import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AdditionSubtractionMultiplicationAndDivision',
  field: 'Number',
  weeks: [3, 7],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/1AddAndSubtractIntegers" */ './1AddAndSubtractIntegers'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/2CommonFactors" */ './2CommonFactors'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/3CommonMultiples" */ './3CommonMultiples'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/4RulesOfDivisibility" */ './4RulesOfDivisibility'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/5PrimesTo100" */ './5PrimesTo100'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/6SquareAndCubeNumbers" */ './6SquareAndCubeNumbers'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/7MultiplyUpToA4DigitNumberByA2DigitNumber" */ './7MultiplyUpToA4DigitNumberByA2DigitNumber'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/8SolveProblemsWithMultiplication" */ './8SolveProblemsWithMultiplication'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/9ShortDivision" */ './9ShortDivision'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/10DivisionUsingFactors" */ './10DivisionUsingFactors'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/11IntroductionToLongDivision" */ './11IntroductionToLongDivision'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/12LongDivisionWithRemainders" */ './12LongDivisionWithRemainders'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/13SolveProblemsWithDivision" */ './13SolveProblemsWithDivision'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/14SolveMultiStepProblems" */ './14SolveMultiStepProblems'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/15OrderOfOperations" */ './15OrderOfOperations'
        )
    }),
    // Step 16
    newSmallStepContent({
      ...BlockModel.smallSteps[15],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/16MentalCalculationsAndEstimation" */ './16MentalCalculationsAndEstimation'
        )
    }),
    // Step 17
    newSmallStepContent({
      ...BlockModel.smallSteps[16],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/AdditionSubtractionMultiplicationAndDivision/17ReasonFromKnownFacts" */ './17ReasonFromKnownFacts'
        )
    })
  ]
});
export default Block;
